import { render, staticRenderFns } from "./msqManagement.vue?vue&type=template&id=22f03656&scoped=true&"
import script from "./msqManagement.vue?vue&type=script&lang=js&"
export * from "./msqManagement.vue?vue&type=script&lang=js&"
import style0 from "./msqManagement.vue?vue&type=style&index=0&id=22f03656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f03656",
  null
  
)

export default component.exports